<template>
  <div>
    <div class="box-card">
      <div style="margin-bottom: 10px"><i class="card-line"></i>班级分组</div>

      <!--      <div style="margin: 10px 0">-->
      <!--        <span style="font-size: 13px;font-weight: 400">用户名：</span>-->
      <!--        <el-input v-model="userInput" style="width: 200px;margin: 0 10px" placeholder="请输入关键字" clearable size="mini"></el-input>-->
      <!--        <el-button size="mini" type="warning" @click="getUserList">搜索</el-button>-->
      <!--      </div>-->
      <spread-table v-loading="loading" :tableHeight="tableHeight" :operation="operation" :pageSize="pageSize"
        :currentPage="currentPage" :total="total" @sizeChange="sizeChange" @currentChange="currentChange"
        @clickButton="clickButton" :tableColumn="drafrList" :tableData="spreadTable"></spread-table>
    </div>

    <el-dialog title="修改余额" v-model="showRoleDia" width="30%">
      <span>
        <span>修改余额：</span>
        <el-input v-model="setMoney" placeholder="请输入余额" size="mini" style="width: 200px"></el-input>
      </span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="backDia">取 消</el-button>
          <el-button type="primary" @click="saveInfo">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import SpreadTable from '@/components/SpreadTable'
import { classGroupData } from "./classGroupData";
import {
  clickButtons, currentChanges, sizeChanges, getUserLists,
  backInfo, saveInfos
} from "./classGroupMethods";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "index",
  components: {
    SpreadTable,
  },
  setup() {
    let router = useRouter();
    onMounted(() => {
      getUserList()
    })
    let data = reactive(classGroupData)
    let getUserList = () => { getUserLists(data) }
    let sizeChange = (val) => { sizeChanges(val, data) }
    let currentChange = (val) => { currentChanges(val, data) }
    let clickButton = (val) => { clickButtons(val, data, router) }
    let backDia = () => { backInfo(data) }
    let saveInfo = () => { saveInfos(data) }

    return {
      ...toRefs(data),
      getUserList,
      sizeChange,
      currentChange,
      clickButton,
      backDia,
      saveInfo,
    }
  }
})
</script>

<style scoped lang="less">
.card-line {
  display: inline-block;
  width: 3px;
  height: 13px;
  border-radius: 8px;
  margin-right: 10px;

  background: #3B6EFB;
}
</style>